export const ClaimTypeEnum = Object.freeze({
  RECEIVE: "RECEIVE",
  DELIVERY: "DELIVERY",
});
